export function lazyload(url) {
    // based on https://friendlybit.com/js/lazy-loading-asyncronous-javascript/

    let scripts = document.getElementsByTagName('script');
    for (let i = scripts.length; i--;) {
        if (scripts[i].src.match(url)) return true;
    }

    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = url;
    let x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);

    return true;
}

export function whenDefined(context: any, variable: string, callback: () => void) {
    if (!!context[variable]) {
        callback();
    } else {
        Object.defineProperty(context, variable, {
            configurable: true,
            enumerable: true,
            get: () => this[`_${variable}`],
            set: (v: any) => {
                this[`_${variable}`] = v;
                callback();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/script.utils.ts